import SBEditable from "../../../components/sbEditable/sbEditable"

import { ArticlePanelOptionsToClasses } from "../articlePanelHelpers"

function HTMLEmbed({ blok }) {
  return (
    <SBEditable blok={blok} withClass={ArticlePanelOptionsToClasses(blok)}>
      <div dangerouslySetInnerHTML={{__html: blok.htmlembed}} style={{maxWidth: "100%",overflow: "clip"}} />
    </SBEditable>
  )
}

export default HTMLEmbed